export class ChangePasswordModel {
    currentPassword: string;
    newPassword: string;
}
